/* __next_internal_client_entry_do_not_use__ RenderHomePage auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { LoggedOutHomePage } from "@faire/retailer-visitor-shared/views/home/logged-out-homepage/LoggedOutHomePage";
import React from "react";
export var RenderHomePage = function(param) {
    var builderPromise = param.builderPromise;
    return /*#__PURE__*/ _jsx(LoggedOutHomePage, {
        builderPromise: builderPromise
    });
};
